.dataType-confirmed {
  background: var(--paletteBlue0);
  color: var(--paletteWhite0);
}

.dataType-partially_confirmed {
  background: var(--paletteBlue0);
  color: var(--paletteWhite0);
}

.dataType-booked {
  background: var(--paletteWorkflowStateBooked);
  color: var(--paletteWhite0);
}

.dataType-partially_booked {
  background: var(--paletteWorkflowStateBooked);
  opacity: 0.6;
  color: var(--paletteWhite0);
}

.dataType-filled {
  background: var(--palettePrimary0);
  color: var(--paletteWhite0);
}

.dataType-partially_filled {
  background: var(--paletteBlue2);
  color: var(--paletteWhite0);
}

.dataType-shortlisting {
  background: var(--palettePrimaryAction);
  color: var(--paletteBlue0);
}

.dataType-not_filled {
  background: var(--paletteOrange4);
  color: var(--paletteBlue0);
}

.dataType-auto_filling {
  background: var(--paletteWorkflowStateAutoFilling);
  color: var(--palettePrimary0);
}

.dataType-auto_shortlisting {
  background: var(--paletteWorkflowStateAutoShortlisting);
  color: var(--palettePrimaryAction);
}
